const CACHE_IMAGE_API = '/infographics/cache_image';

type CacheImageResponse = {
  status: string;
  url: string;
  delay: number;
};

export const cacheImages = (pageURL: string, imageURL?: string) => {
  return new Promise<CacheImageResponse>((resolve, reject) => {
    if (!pageURL || !imageURL) {
      reject(new Error('imageURL to be cached is invalid'));
      return;
    }

    fetch(`${CACHE_IMAGE_API}/${pageURL}`, {
      method: 'POST',
      body: `image_url=${encodeURIComponent(imageURL)}`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'x-requested-with': 'XMLHttpRequest',
      },
    })
      .then((httpResponse) => {
        if (!httpResponse.ok) {
          throw new Error('cache image fail');
        }

        const jsonResponse = httpResponse.json();
        resolve(jsonResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
